export enum TimeUnits {
  minutes = 'minutes',
  hours = 'hours',
  days = 'days'
}



// WEBPACK FOOTER //
// ./src/components/TaskManagement/domain/enums/TimeUnits.ts